import {createAsyncThunk} from "@reduxjs/toolkit";
import apiInstanceV2 from "../../Apis/AxiosV2";
import {PAYROLL_POLICY_GROUP_SERVICE, PAYROLL_POLICY_SERVICE, PAYROLL_RESULT_SERVICE} from "../EndPoints";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */

export const GetPayrollPolicy = createAsyncThunk(
    'payrollPolicyService/getPayrollPolicy',
    async (id) => {
        const result = await apiInstanceV2
            .get(`${PAYROLL_POLICY_SERVICE.getPayrollPolicy}${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetPayrollPolicyByGroupId = createAsyncThunk(
    'deductionPolicyService/getAllDeductionPoliciesByGroupId',
    async (id) => {
        const result = await apiInstanceV2
            .get(`${PAYROLL_POLICY_SERVICE.getPayrollPolicyByGroupId}${id}`)
            .then(r => r)
            .catch(e => e.response);
        return { data: result.data, status: result.status };
    },
);

export const UpdatePayrollPolicy = createAsyncThunk(
    'payrollPolicyService/updatePayrollPolicy',
    async (body) => {
        const result = await apiInstanceV2
            .put(`${PAYROLL_POLICY_SERVICE.updatePayrollPolicy}`, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const UpdatePriorityPayrollPolicy = createAsyncThunk(
    'payrollPolicyService/updatePriorityPayrollPolicy',
    async (body) => {
        const result = await apiInstanceV2
            .put(`${PAYROLL_POLICY_SERVICE.updatePriorityPayrollPolicy}`, body)
            .then(function (response) { return response; })
            .catch(function (error) { return error.response; });
        const { data, status } = result;
        return { data, status };
    },
);

export const UpdateStatusPayrollPolicy = createAsyncThunk(
    'payrollPolicyService/updateStatusPayrollPolicy',
    async (body) => {
        const result = await apiInstanceV2
            .put(`${PAYROLL_POLICY_SERVICE.updateStatusPayrollPolicy}`, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

//*************PAYROLL POLICY GROUP****************************************************
export const CreatePayrollPolicyGroup = createAsyncThunk(
    'payrollPolicyService/createPayrollPolicyGroup',
    async (body) => {
        const result = await apiInstanceV2
            .post(`${PAYROLL_POLICY_GROUP_SERVICE.createPayrollPolicyGroup}`, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetPayrollPolicyGroup = createAsyncThunk(
    'payrollPolicyService/getPayrollPolicyGroup',
    async (id) => {
        const result = await apiInstanceV2
            .get(`${PAYROLL_POLICY_GROUP_SERVICE.getPayrollPolicyGroup}${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const UpdatePayrollPolicyGroup = createAsyncThunk(
    'payrollPolicyService/updatePayrollPolicyGroup',
    async (body) => {
        const result = await apiInstanceV2
            .put(`${PAYROLL_POLICY_GROUP_SERVICE.updatePayrollPolicyGroup}`, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const UpdateStatusPayrollPolicyGroup = createAsyncThunk(
    'payrollPolicyService/updateStatusPayrollPolicy',
    async (body) => {
        const result = await apiInstanceV2
            .put(`${PAYROLL_POLICY_GROUP_SERVICE.updateStatusPayrollPolicyGroup}`, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


//*************PAYROLL RESULT****************************************************

export const GetPayrollResultById = createAsyncThunk(
    'payrollPolicyService/getPayrollResultById',
    async (id) => {
        const result = await apiInstanceV2
            .get(`${PAYROLL_RESULT_SERVICE.getPayrollResultById}${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetOvertimeByPayrollResultId = createAsyncThunk(
    'payrollPolicyService/getOvertimeByPayrollResultId',
    async (id) => {
        const result = await apiInstanceV2
            .get(`${PAYROLL_RESULT_SERVICE.getOvertimeByPayrollResultId}${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetDeductionByPayrollResultId = createAsyncThunk(
    'payrollPolicyService/getDeductionByPayrollResultId',
    async (id) => {
        const result = await apiInstanceV2
            .get(`${PAYROLL_RESULT_SERVICE.getDeductionByPayrollResultId}${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetPayrollResultPeriodYears = createAsyncThunk(
    'payrollPolicyService/getPayrollResultPeriodYears',
    async () => {
        const result = await apiInstanceV2
            .get(`${PAYROLL_RESULT_SERVICE.getPayrollResultPeriodYears}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetFinishedPayrollResultPeriodsByYear = createAsyncThunk(
    'payrollPolicyService/getFinishedPayrollResultPeriodsByYear',
    async (year) => {
        const result = await apiInstanceV2
            .get(`${PAYROLL_RESULT_SERVICE.getFinishedPayrollResultPeriodsByYear}${year}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const UpdatePayrollUser = createAsyncThunk(
    'payrollPolicyService/updatePayrollUser',
    async (id) => {
        const result = await apiInstanceV2
            .get(`${PAYROLL_RESULT_SERVICE.updatePayrollUser}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetOvertimePolicyGroupConfig = createAsyncThunk(
    'payrollPolicyService/getOvertimePolicyGroupConfig',
    async () => {
        const result = await apiInstanceV2
            .get(`${PAYROLL_POLICY_GROUP_SERVICE.getOvertimePolicyGroupConfig}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const UpdateOvertimePolicyGroupConfig = createAsyncThunk(
    'payrollPolicyService/updateOvertimePolicyGroupConfig',
    async (body) => {
        const result = await apiInstanceV2
            .put(`${PAYROLL_POLICY_GROUP_SERVICE.updateOvertimePolicyGroupConfig}`, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);



